import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconSearch(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        x="2.48714"
        y="7.43005"
        width="7"
        height="7"
        rx="3.5"
        transform="rotate(-45 2.48714 7.43005)"
        stroke="currentColor"
      />
      <path d="M9.91174 9.90491L13.8008 13.794" stroke="currentColor" />
    </SVGIcon>
  );
}
